import React from 'react';
import { WHATSAPP_GROUP_URL } from '../utils/community';
import './WhatsAppGroupButton.css';

export default function WhatsAppGroupButton() {
  return (
    <a className="whatsapp-group-float" href={WHATSAPP_GROUP_URL} target="_blank" rel="noopener noreferrer" aria-label="Rejoindre le groupe WhatsApp Démarcheur">
      <span className="whatsapp-group-icon" aria-hidden="true">W</span>
      <span className="whatsapp-group-copy"><strong>Groupe WhatsApp</strong><small>Rejoindre la communauté</small></span>
    </a>
  );
}
